import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "./pages/Landing";
import InspectionDefense from "./pages/InspectionDefense";
import Press from "./pages/Press";
import MirrorBloom from "./pages/MirrorBloom";
import CitationCalm from "./pages/CitationCalm";
import QuizPage from "./pages/QuizPage";
import App from "./App";
import CheckoutRedirect from "./pages/CheckoutRedirect";
import A11yGate from "./pages/A11yGate";
import "./theme.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/app" element={<App />} />
          <Route path="/inspection-defense" element={<InspectionDefense />} />
          <Route path="/press" element={<Press />} />
          <Route path="/mirror-bloom" element={<MirrorBloom />} />
          <Route path="/for-directors" element={<CitationCalm />} />
          <Route path="/start" element={<QuizPage />} />
                <Route path="/checkout/:key" element={<CheckoutRedirect />} />
        <Route path="/a11y" element={<A11yGate />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
